import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaLinkedinIn, FaTwitter, FaFacebookF, FaInstagram, FaYoutube, FaChevronDown, FaChevronUp, FaChevronRight, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import logo from '../assets/logo.png';

const FullScreenFooter = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showPremiumSolutions, setShowPremiumSolutions] = useState(false);
  const [showAIHealthcare, setShowAIHealthcare] = useState(false);
  const [showInsuranceVerification, setShowInsuranceVerification] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer 
      style={{ 
        backgroundColor: '#001F2B', 
        color: '#ffffff',
        fontFamily: "'Poppins', sans-serif"
      }}
      itemScope 
      itemType="https://schema.org/Organization"
    >
      {/* Contact Us Section - Prominent Top Section */}
      <div style={{
        background: 'linear-gradient(135deg, #003545 0%, #001F2B 100%)',
        padding: isMobile ? '40px 20px' : '50px 5%',
        borderBottom: '2px solid #F26522'
      }}>
        <div style={{ 
          maxWidth: '1400px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: isMobile ? '28px' : '36px',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '10px',
            color: '#ffffff'
          }}>
            Contact Our Offices
          </h2>
          <p style={{
            textAlign: 'center',
            color: '#b3b3b3',
            marginBottom: '40px',
            fontSize: '16px'
          }}>
            Get in touch with our expert team for healthcare revenue cycle management solutions
          </p>

          {/* Location Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: isMobile ? '30px' : '50px',
            maxWidth: '1100px',
            margin: '0 auto'
          }}>
            {/* US Office Card */}
            <div style={{
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '12px',
              padding: isMobile ? '25px' : '35px',
              border: '1px solid rgba(242, 101, 34, 0.3)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(242, 101, 34, 0.2)';
              e.currentTarget.style.borderColor = '#F26522';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'rgba(242, 101, 34, 0.3)';
            }}
            itemScope 
            itemType="https://schema.org/PostalAddress"
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  backgroundColor: '#F26522',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  fontWeight: 'bold'
                }}>
                  🇺🇸
                </div>
                <div>
                  <h3 style={{
                    fontSize: '22px',
                    fontWeight: '700',
                    color: '#F26522',
                    margin: 0
                  }}>
                    USA Office
                  </h3>
                  <p style={{ fontSize: '14px', color: '#b3b3b3', margin: 0 }}>
                    MDeRCM Solutions LLC
                  </p>
                </div>
              </div>

              <div style={{ marginBottom: '15px' }}>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
                  <FaMapMarkerAlt style={{ color: '#F26522', fontSize: '16px', marginTop: '4px', flexShrink: 0 }} />
                  <div style={{ lineHeight: '1.6', fontSize: '14px' }}>
                    <span itemProp="streetAddress">Five Greentree Centre, 525 Route 73 North, Suite 104</span><br />
                    <span itemProp="addressLocality">Marlton</span>, <span itemProp="addressRegion">NJ</span> <span itemProp="postalCode">08053</span>, <span itemProp="addressCountry">USA</span>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '10px', marginBottom: '12px', alignItems: 'center' }}>
                <FaPhone style={{ color: '#F26522', fontSize: '14px' }} />
                <a 
                  href="tel:+15103566069" 
                  style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: '500'
                  }}
                  itemProp="telephone"
                >
                  +1 (510) 356-6069
                </a>
              </div>

              <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', alignItems: 'center' }}>
                <FaEnvelope style={{ color: '#F26522', fontSize: '14px' }} />
                <a 
                  href="mailto:sales@mdercm.com" 
                  style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px'
                  }}
                  itemProp="email"
                >
                  sales@mdercm.com
                </a>
              </div>

           
            </div>

            {/* India Office Card */}
            <div style={{
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '12px',
              padding: isMobile ? '25px' : '35px',
              border: '1px solid rgba(242, 101, 34, 0.3)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(242, 101, 34, 0.2)';
              e.currentTarget.style.borderColor = '#F26522';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = 'rgba(242, 101, 34, 0.3)';
            }}
            itemScope 
            itemType="https://schema.org/PostalAddress"
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  backgroundColor: '#F26522',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  fontWeight: 'bold'
                }}>
                  🇮🇳
                </div>
                <div>
                  <h3 style={{
                    fontSize: '22px',
                    fontWeight: '700',
                    color: '#F26522',
                    margin: 0
                  }}>
                    India Office
                  </h3>
                  <p style={{ fontSize: '14px', color: '#b3b3b3', margin: 0 }}>
                    MDeRCM Solutions Private Limited
                  </p>
                </div>
              </div>

              <div style={{ marginBottom: '15px' }}>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
                  <FaMapMarkerAlt style={{ color: '#F26522', fontSize: '16px', marginTop: '4px', flexShrink: 0 }} />
                  <div style={{ lineHeight: '1.6', fontSize: '14px' }}>
                    <span itemProp="streetAddress">DLF Forum, Cybercity, Phase III</span><br />
                    <span itemProp="addressLocality">Gurugram</span>, <span itemProp="addressRegion">Haryana</span> <span itemProp="postalCode">122002</span>, <span itemProp="addressCountry">India</span>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '10px', marginBottom: '12px', alignItems: 'center' }}>
                <FaPhone style={{ color: '#F26522', fontSize: '14px' }} />
                <a 
                  href="tel:+919311250055" 
                  style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: '500'
                  }}
                  itemProp="telephone"
                >
                  +91-9311250055
                </a>
              </div>

              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <FaEnvelope style={{ color: '#F26522', fontSize: '14px' }} />
                <a 
                  href="mailto:sales@mdercm.com" 
                  style={{
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontSize: '14px'
                  }}
                  itemProp="email"
                >
                  sales@mdercm.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div style={{ 
        padding: isMobile ? '40px 20px' : '60px 5%',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: isMobile ? '40px' : '40px',
          marginBottom: '40px'
        }}>
          
          {/* Column 1: Company Info & Logo */}
          <div>
            <img
              src={logo}
              alt="MDeRCM - Healthcare Revenue Cycle Management Services"
              style={{
                height: isMobile ? '60px' : '70px',
                width: 'auto',
                maxWidth: '250px',
                marginBottom: '20px'
              }}
              itemProp="logo"
            />
            <meta itemProp="name" content="MDeRCM Solutions LLC" />
            <p style={{
              fontSize: '14px',
              lineHeight: '1.6',
              color: '#b3b3b3',
              marginBottom: '20px'
            }}>
              Leading provider of <strong>healthcare revenue cycle management services</strong>, <strong>medical billing outsourcing</strong>, and <strong>revenue cycle management consulting services</strong> for hospitals and healthcare providers across the USA and India.
            </p>
            
            {/* Social Icons */}
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <a 
                href="https://www.linkedin.com/company/mdercm-solutions-llc" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={iconStyle}
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
              <a href="/" style={iconStyle} aria-label="Twitter"><FaTwitter /></a>
              <a href="/" style={iconStyle} aria-label="Facebook"><FaFacebookF /></a>
              <a href="/" style={iconStyle} aria-label="Instagram"><FaInstagram /></a>
              <a href="/" style={iconStyle} aria-label="YouTube"><FaYoutube /></a>
            </div>
          </div>

          {/* Column 2: RCM Services */}
          <div>
            <h3 style={headingStyle}>RCM Services</h3>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                <Link to="/pricing/" style={footerLinkStyle}>
                  Pricing & Plans
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/medical-billing-outsourcing-small-practices/" style={footerLinkStyle}>
                  Small Practice Billing
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/reduce-claim-denials-healthcare-billing/" style={footerLinkStyle}>
                  Reduce Claim Denials
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/revenue-cycle-management-independent-physicians/" style={footerLinkStyle}>
                  Independent Physician RCM
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/denial-management-services-medical-clinics/" style={footerLinkStyle}>
                  Denial Management
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/revenue-cycle-management-multispecialty-practices/" style={footerLinkStyle}>
                  Multispecialty RCM
                </Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/benefits-medical-billing-outsourcing-clinics/" style={footerLinkStyle}>
                  Outsourcing Benefits
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div>
            <h3 style={headingStyle}>Quick Links</h3>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                <Link to="/" style={footerLinkStyle}>Home</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/why/" style={footerLinkStyle}>Why MDRCM</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/company/" style={footerLinkStyle}>Company</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/healthcare/ai/" style={footerLinkStyle}>AI Healthcare Solutions</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/blog/" style={footerLinkStyle}>Blog</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/careers/" style={footerLinkStyle}>Careers</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/compliance/" style={footerLinkStyle}>Compliance</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/events/" style={footerLinkStyle}>Events</Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Premium Solutions & Resources */}
          <div>
            <h3 style={headingStyle}>Premium Solutions</h3>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                <Link to="/Dental/" style={footerLinkStyle}>Dental Health</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/MentalHealth/" style={footerLinkStyle}>Mental Health</Link>
              </li>
            </ul>
            
            <h3 style={{...headingStyle, marginTop: '30px'}}>Resources</h3>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                <Link to="/resources/" style={footerLinkStyle}>All Resources</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/resources/denial-codes/" style={footerLinkStyle}>Denial Codes</Link>
              </li>
              <li style={listItemStyle}>
                <Link to="/free-trial/" style={footerLinkStyle}>Free Trial</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* SEO-Rich Keywords Section */}
        <div style={{
          padding: isMobile ? '20px 0' : '30px 0',
          borderTop: '1px solid #ffffff33',
          borderBottom: '1px solid #ffffff33',
          marginBottom: '30px'
        }}>
          <p style={{
            fontSize: '12px',
            lineHeight: '1.8',
            color: '#808080',
            textAlign: 'center'
          }}>
            <strong>Specializing in:</strong> Healthcare Revenue Cycle Management Services | Medical Revenue Cycle Management Services | Outsourced Revenue Cycle Management Services | Revenue Cycle Management Consulting Services | Revenue Cycle Management Services Companies | Revenue Cycle Management Services for Hospitals | Medical Billing and Coding Outsourcing | Medical Billing Outsourcing Companies | Medical Billing Outsourcing Services | Hospital Revenue Cycle Management | Healthcare Cost Reduction Consulting | Healthcare Cost Reduction Strategies | How to Improve Revenue Cycle Management | Best Revenue Cycle Management Companies | Revenue Cycle Management Services USA | Medical Billing Outsourcing for Small Practices | Reduce Claim Denials in Healthcare Billing | Revenue Cycle Management for Independent Physicians | Denial Management Services for Medical Clinics | Revenue Cycle Management for Multispecialty Practices | Benefits of Medical Billing Outsourcing for Clinics
          </p>
        </div>

        {/* Navigation Menu */}
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: isMobile ? '15px' : '8px',
            padding: '20px 0',
            borderBottom: '1px solid #ffffff33',
            marginBottom: '20px'
          }}
        >
          {[
            { label: 'Home', to: '/' },
            { label: 'Why MDRCM', to: '/why' },
            { label: 'AI Healthcare', to: '/healthcare/ai' },
            { label: 'Dental', to: '/Dental' },
            { label: 'Mental Health', to: '/MentalHealth' },
            { label: 'Blog', to: '/blog' },
            { label: 'Events', to: '/events' },
            { label: 'Resources', to: '/resources' },
            { label: 'Company', to: '/company' },
            { label: 'Compliance', to: '/compliance' },
            { label: 'Careers', to: '/careers' },
          ].map((link, index, arr) => {
            const isActive = location.pathname === link.to;
            return (
              <React.Fragment key={link.to}>
                <Link
                  to={link.to}
                  style={isActive ? navLinkActive : navLink}
                  onMouseEnter={(e) => {
                    if (!isActive) e.target.style.color = '#F26522';
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive) e.target.style.color = '#ffffff';
                  }}
                >
                  {link.label}
                </Link>
                {!isMobile && index !== arr.length - 1 && (
                  <span style={{ color: '#666', padding: '0 5px' }}>|</span>
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Bottom Bar - Copyright & Legal */}
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '15px',
          paddingTop: '20px'
        }}>
          <p style={{
            fontSize: '13px',
            color: '#999',
            margin: 0,
            textAlign: isMobile ? 'center' : 'left'
          }}>
            © {new Date().getFullYear()} MDeRCM Solutions LLC. All rights reserved.
            {' | '}
            Powered By: <a 
              href="https://businessaisoftware.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                color: '#F26522',
                textDecoration: 'none',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
              onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
            >
              Business AI Software
            </a>
          </p>
          
          <div style={{
            display: 'flex',
            gap: isMobile ? '15px' : '20px',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            <Link to="/privacy/" style={legalLinkStyle}>Privacy Policy</Link>
          </div>
        </div>
      </div>

      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "MDeRCM Solutions LLC",
          "url": "https://www.mdercm.com",
          "logo": "https://www.mdercm.com/logo.png",
          "description": "Leading provider of healthcare revenue cycle management services, medical billing outsourcing, and RCM consulting services for hospitals and healthcare providers.",
          "address": [
            {
              "@type": "PostalAddress",
              "streetAddress": "Five Greentree Centre, 525 Route 73 North, Suite 104",
              "addressLocality": "Marlton",
              "addressRegion": "NJ",
              "postalCode": "08053",
              "addressCountry": "US"
            },
            {
              "@type": "PostalAddress",
              "streetAddress": "DLF Forum, Cybercity, Phase III",
              "addressLocality": "Gurugram",
              "addressRegion": "Haryana",
              "postalCode": "122002",
              "addressCountry": "IN"
            }
          ],
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+1-510-356-6069",
              "contactType": "customer service",
              "areaServed": "US"
            },
            {
              "@type": "ContactPoint",
              "telephone": "+91-9311250055",
              "contactType": "customer service",
              "areaServed": "IN"
            }
          ],
          "sameAs": [
            "https://www.linkedin.com/company/mdercm-solutions-llc"
          ]
        })}
      </script>
    </footer>
  );
};

// Styles
const headingStyle = {
  fontSize: '18px',
  fontWeight: '700',
  marginBottom: '20px',
  color: '#ffffff',
  borderBottom: '2px solid #F26522',
  paddingBottom: '10px',
  display: 'inline-block'
};

const listStyle = {
  listStyle: 'none',
  padding: 0,
  margin: 0
};

const listItemStyle = {
  marginBottom: '12px'
};

const footerLinkStyle = {
  color: '#b3b3b3',
  textDecoration: 'none',
  fontSize: '14px',
  transition: 'all 0.3s ease',
  display: 'inline-block'
};

const contactItemStyle = {
  display: 'flex',
  gap: '12px',
  alignItems: 'flex-start',
  marginBottom: '15px',
  fontSize: '14px',
  lineHeight: '1.6',
  color: '#b3b3b3'
};

const contactLinkStyle = {
  color: '#b3b3b3',
  textDecoration: 'none',
  transition: 'color 0.3s ease'
};

const locationTabStyle = {
  background: 'none',
  border: 'none',
  padding: '10px 15px',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: '600',
  transition: 'all 0.3s ease',
  fontFamily: "'Poppins', sans-serif"
};

const navLink = {
  color: '#b3b3b3',
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: 500,
  transition: 'color 0.3s ease',
};

const navLinkActive = {
  ...navLink,
  color: '#F26522',
  fontWeight: 600
};

const iconStyle = {
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  color: '#001F2B',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '16px',
  textDecoration: 'none',
  transition: 'all 0.3s ease',
  cursor: 'pointer'
};

const legalLinkStyle = {
  color: '#999',
  textDecoration: 'none',
  fontSize: '13px',
  transition: 'color 0.3s ease'
};

export default FullScreenFooter;